export const QIColums = [
  {
    title: "#",
    dataIndex: "id",
    key: "id",
    width: 40,
    customRender: (text, record, index) => {
      return index + 1;
    },
  },
  {
    title: "时间",
    dataIndex: "placeholder",
    key: "placeholder",
  },
  {
    title: "库区类型",
    dataIndex: "placeholder",
    key: "placeholder",
  },
  {
    title: "前一天遗留数量",
    dataIndex: "placeholder",
    key: "placeholder",
  },
  {
    title: "进入质检区数量",
    dataIndex: "placeholder",
    key: "placeholder",
  },
  {
    title: '出质检区数量',
    dataIndex: 'placeholder',
    key: 'placeholder',
  },
  {
    title: '质检房留存数量',
    dataIndex: 'placeholder',
    key: 'placeholder',
  },
  {
    title: '批次号',
    dataIndex: 'placeholder',
    key: 'placeholder',
  },
  {
    title: 'SKU',
    dataIndex: 'placeholder',
    key: 'placeholder',
  },
  {
    title: '数量',
    dataIndex: 'placeholder',
    key: 'placeholder',
  },
  {
    title: '类型',
    dataIndex: 'placeholder',
    key: 'placeholder',
  },
];
